export default "__VITE_ASSET__DFVGN4LL__"